import * as React from "react";
import ChevronLeft20 from "@/icons/__generated__/ChevronLeft/ChevronLeft20";
import ChevronRight20 from "@/icons/__generated__/ChevronRight/ChevronRight20";
import { cn } from "@/lib/utils";

interface ArrowButtonProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  testId?: string;
  right?: boolean;
  className?: string;
  disabled?: boolean;
}

export const ArrowButton = React.forwardRef<
  HTMLButtonElement,
  ArrowButtonProps
>(({ onClick, testId, right, className, disabled, ...props }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className={cn(
        className,
        "tw-border-transparent tw-bg-gray-900 tw-text-base-white tw-body-1-m tw-rounded-circular tw-p-6 tw-w-32 tw-h-32 tw-opacity-70 hover:tw-opacity-100 tw-transition-opacity tw-duration-200 tw-flex tw-items-center tw-justify-center",
      )}
      data-testid={testId}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {right ? <ChevronRight20 /> : <ChevronLeft20 />}
    </button>
  );
});

ArrowButton.displayName = "ArrowButton";
